import { ApplicationConfig, provideZoneChangeDetection } from '@angular/core';
import { provideRouter, RouteReuseStrategy } from '@angular/router';
import { providePrimeNG } from 'primeng/config';
import Aura from '@primeng/themes/aura';
import { definePreset } from '@primeng/themes';
import { routes } from './app.routes';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { sessionInterceptor } from './modules/besharp-sessions/lib/utils/interceptor';
import { ChatReuseStrategy } from './core/routing/chat-reuse-strategy';

const themeOptions = {
  primary: 'sky',
};

export const appConfig: ApplicationConfig = {
  providers: [
    provideAnimationsAsync(),
    provideHttpClient(withInterceptors([sessionInterceptor])),
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    { provide: RouteReuseStrategy, useClass: ChatReuseStrategy },
    providePrimeNG({
      theme: {
        preset: definePreset(Aura, {
          semantic: {
            primary: {
              50: `{${themeOptions.primary}.50}`,
              100: `{${themeOptions.primary}.100}`,
              200: `{${themeOptions.primary}.200}`,
              300: `{${themeOptions.primary}.300}`,
              400: `{${themeOptions.primary}.400}`,
              500: `{${themeOptions.primary}.500}`,
              600: `{${themeOptions.primary}.600}`,
              700: `{${themeOptions.primary}.700}`,
              800: `{${themeOptions.primary}.800}`,
              900: `{${themeOptions.primary}.900}`,
              950: `{${themeOptions.primary}.950}`,
            },
          },
        }),
        options: {
          darkModeSelector: '.dark-mode',
        },
      },
    }),
  ],
};
